// The panel's scrolling, the one piece of the sheet that needs the DOM.

/**
 * Scroll `box` (the panel, its own scroll container) just enough that `cell`
 * is inside it with a small margin. Unlike `scrollIntoView` this never
 * scrolls any ancestor, so the page and the board stay where they are.
 */
export function keepInView(box: HTMLElement, cell: HTMLElement, margin = 8): void {
  const boxRect = box.getBoundingClientRect();
  const cellRect = cell.getBoundingClientRect();
  const above = cellRect.top - margin - boxRect.top;
  const below = cellRect.bottom + margin - boxRect.bottom;
  if (above < 0) box.scrollTop += above;
  else if (below > 0) box.scrollTop += below;
}
